import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { convertUTCToLocal } from "utils/time";
import { fetchSkills } from "store/modules/skills/actions";
import { selectors as SkillSelectors } from "store/modules/skills";
import SkillActionMenu from "./SkillActionMenu";
import { Chip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ReactTableSimple from "components/ReactTable/ReactTableSimple";

const useStyles = makeStyles(theme => ({
    ActiveChip: {
        background: "#4caf50",
        color: "#fff"
    },
    InactiveChip: {
        background: theme.customPalette.red[500],
        color: "#fff"
    }
}));

function SkillsTable({ onDelete,onEdit }) {

    const dispatch = useDispatch();
    const data = useSelector(SkillSelectors.getSkillsList);
    const isLoading = useSelector(SkillSelectors.getIsTableLoading);

    useEffect(() => {
        dispatch(fetchSkills());
    }, [])

    return (
        <ReactTableSimple
            classes="-highlight"
            loading={isLoading}
            data={data}
            columns={[
                {
                    Header: "Skill Name",
                    id: "skillName",
                    disableFilters: true,
                    disableSortBy: true,
                    accessor: ({ skillName }) => skillName,
                },
                {
                    Header: "Skill Name In French",
                    id: "frenchSkillName",
                    disableFilters: true,
                    disableSortBy: true,
                    accessor: ({ frenchSkillName }) => frenchSkillName,
                },
                // {
                //     Header: "Active",
                //     id: "isActive",
                //    disableFilters:true,
                //     disableSortBy:true,
                //     Cell: ({ original }) => {
                //         const { isActive } = original;
                //         if (isActive === true) {
                //             return (
                //                 <div>
                //                     <Chip label="Active" size="small" className={classes.ActiveChip} />
                //                 </div>
                //             )
                //         }
                //         else {
                //             return (
                //                 <div>
                //                     <Chip label="Inactive" size="small" className={classes.InactiveChip} />
                //                 </div>
                //             )
                //         }
                //     }
                // },
                {
                    Header: "Created",
                    id: "createdAt",
                    disableFilters: true,
                    disableSortBy: true,
                    accessor: ({ createdAt }) => convertUTCToLocal(createdAt, "MMM Do, YYYY"),
                },
                {
                    id: "actions",
                    disableSortBy: true,
                    disableFilters: true,
                    collapse: true,
                    Cell: ({ row:{original} }) => {
                        const { id } = original;
                        return (
                            <SkillActionMenu
                                id={id}
                                data={original}
                                onDelete={onDelete}
                                onEdit={onEdit}
                            />
                        );
                    },
                },
            ]}
        />
    )
}

export default SkillsTable
